import { COUNTRY_COOKIE_KEY, LOCALE_COOKIE_KEY } from '@/utils/constants'
export default defineNuxtRouteMiddleware(() => {
  const countryCookie = useCookie(COUNTRY_COOKIE_KEY).value
  const { $mRouter } = useNuxtApp()
  if (countryCookie) {
    const savedLocale = useCookie(LOCALE_COOKIE_KEY).value || useLocale()
    const slug = useCookie(`${COUNTRY_COOKIE_KEY}.${savedLocale}`).value
    if (slug) {
      const route = $mRouter.getRouteForLocale({ name: 'country', params: { country: slug } }, savedLocale)
      return navigateTo(route.fullPath)
    } else {
      // api call to fetch the slug
    }
  }
})
